module.exports = __webpack_public_path__ + "static/media/piggy-bank.1835c4b9.bin";